export default __webpack_public_path__ + "static/pay_compare_comp3_inactive-1-dd41b25bae24baaca9104dfddea9c9bd.png";